import { render, staticRenderFns } from "./ParametrosContabilizacion.vue?vue&type=template&id=04fc707d"
import script from "./ParametrosContabilizacion.vue?vue&type=script&lang=js"
export * from "./ParametrosContabilizacion.vue?vue&type=script&lang=js"
import style0 from "./ParametrosContabilizacion.vue?vue&type=style&index=0&id=04fc707d&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports